import { render, staticRenderFns } from "./TransformVariables.vue?vue&type=template&id=3c408d04&"
import script from "./TransformVariables.vue?vue&type=script&lang=js&"
export * from "./TransformVariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports